"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var framer_motion_1 = require("framer-motion");
var phosphor_react_1 = require("phosphor-react");
var react_1 = __importStar(require("react"));
var Buttons_1 = require("../Buttons");
var Typo_1 = require("../Typo");
var colors_1 = require("../../themes/colors");
var utilsOolib_1 = require("../../utilsOolib");
var PercentCompletedPie_1 = require("../PercentCompletedPie");
var Tooltip_1 = require("../Tooltip");
var styled_1 = require("./styled");
var HeaderStyle1 = function (_a) {
    var title = _a.title, expand = _a.expand, handleToggle = _a.handleToggle, infoTooltip = _a.infoTooltip, invert = _a.invert;
    return (react_1.default.createElement(styled_1.StyledHeaderStyle1Wrapper, { onClick: function () { return handleToggle(!expand); } },
        react_1.default.createElement(styled_1.StyledTitleWrapper, null,
            react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, title),
            infoTooltip && (react_1.default.createElement(Tooltip_1.Tooltip, { text: typeof infoTooltip === 'string' ? infoTooltip : infoTooltip.text, position: typeof infoTooltip !== 'string' ? infoTooltip.position || 'right' : 'right', invert: invert, popOutOfOverflowHiddenParent: typeof infoTooltip !== 'string' && infoTooltip.popOutOfOverflowHiddenParent, presetTarget: 'infoIcon' }))),
        react_1.default.createElement(styled_1.NormalizedButton, null,
            react_1.default.createElement(framer_motion_1.motion.div, { animate: { rotate: expand ? -180 : 0 }, transition: { type: 'tween', ease: 'easeOut' } },
                react_1.default.createElement(phosphor_react_1.CaretDown, { size: 16 })))));
};
var HeaderStyle3 = function (_a) {
    var title = _a.title, expand = _a.expand, handleToggle = _a.handleToggle, infoTooltip = _a.infoTooltip, invert = _a.invert;
    return (react_1.default.createElement(styled_1.StyledHeaderStyle3Wrapper, { onClick: function () { return handleToggle(!expand); } },
        react_1.default.createElement(styled_1.StyledTitleWrapper, null,
            react_1.default.createElement(Typo_1.SERIF_4_5, null, title),
            infoTooltip && (react_1.default.createElement(Tooltip_1.Tooltip, { text: typeof infoTooltip === 'string' ? infoTooltip : infoTooltip.text, position: typeof infoTooltip !== 'string' ? infoTooltip.position || 'right' : 'right', invert: invert, popOutOfOverflowHiddenParent: typeof infoTooltip !== 'string' && infoTooltip.popOutOfOverflowHiddenParent, presetTarget: 'infoIcon' }))),
        react_1.default.createElement(styled_1.NormalizedButton, null,
            react_1.default.createElement(framer_motion_1.motion.div, { animate: { rotate: expand ? -180 : 0 }, transition: { type: 'tween', ease: 'easeOut' } },
                react_1.default.createElement(phosphor_react_1.CaretDown, { size: 16 })))));
};
var HeaderStyle2 = function (_a) {
    var title = _a.title, label = _a.label, expand = _a.expand, handleToggle = _a.handleToggle, percent = _a.percent, infoTooltip = _a.infoTooltip, invert = _a.invert;
    return (react_1.default.createElement(styled_1.StyledHeaderStyle2Wrapper, { onClick: function () { return handleToggle(!expand); } },
        react_1.default.createElement(styled_1.StyledTitleHeaderStyle2Wrapper, null,
            percent && react_1.default.createElement(PercentCompletedPie_1.PercentCompletedPie, { percent: percent.value }),
            react_1.default.createElement("div", null,
                label && react_1.default.createElement(Typo_1.LABEL, { style: { color: (0, utilsOolib_1.getPrimaryColor100)(colors_1.colors) } }, label),
                react_1.default.createElement(styled_1.StyledTitleWrapper, null,
                    react_1.default.createElement(Typo_1.SERIF_5_6, null, title),
                    infoTooltip && (react_1.default.createElement(Tooltip_1.Tooltip, { text: typeof infoTooltip === 'string' ? infoTooltip : infoTooltip.text, position: typeof infoTooltip !== 'string' ? infoTooltip.position || 'right' : 'right', invert: invert, popOutOfOverflowHiddenParent: typeof infoTooltip !== 'string' && infoTooltip.popOutOfOverflowHiddenParent, presetTarget: 'infoIcon' }))))),
        react_1.default.createElement(Buttons_1.ButtonGhost, { icon: expand ? 'Minus' : 'Plus' })));
};
/**
 * @component Renders an accordion component with customizable title and content.
 *
 * - The props object containing the following properties:
 * @prop {string} id: A unique ID for the accordion.
 * @prop {'HeaderStyle1' | 'HeaderStyle2' | 'HeaderStyle3'} HeaderStyle: The style of the accordion header. Defaults to "HeaderStyle1".
 * @prop {React.FunctionComponent} CustomHeader: A component that will be used instead of generating a header based on the other props.
 * @prop {boolean} noHeader: A boolean indicating whether to render the header. Defaults to false.
 * @prop {React.ReactNode} children: The content to be rendered inside the accordion.
 * @prop {boolean} expand: A boolean indicating whether the accordion is expanded. Defaults to false.
 * @prop {(expand: boolean) => void} setExpand: A callback function to set the expanded state of the accordion.
 * @prop {string} title: The title of the accordion.
 * @prop {string} label: A label to be displayed next to the title.
 * @prop { string | { text: string; position?: TooltipProps['position']; popOutOfOverflowHiddenParent?: boolean }} infoTooltip: A string or object containing text and optional position & popOutOfOverflowHiddenParent props for the info tooltip.
 * @prop {boolean} invert: A boolean indicating whether to invert the background color of the accordion. Defaults to false.
 * @prop {object} percent: An object containing a "value" property for the percent to be displayed in the pie. e.g. {value: 80}
 * @return {ReactElement} The rendered accordion component.
 */
var Accordion = function (_a) {
    var id = _a.id, _b = _a.HeaderStyle, HeaderStyle = _b === void 0 ? 'HeaderStyle1' : _b, CustomHeader = _a.CustomHeader, _c = _a.noHeader, noHeader = _c === void 0 ? false : _c, children = _a.children, _d = _a.expand, expandProp = _d === void 0 ? false : _d, setExpandProp = _a.setExpand, title = _a.title, label = _a.label, infoTooltip = _a.infoTooltip, invert = _a.invert, percent = _a.percent;
    var _e = (0, react_1.useState)(expandProp), expand = _e[0], setExpand = _e[1];
    var handleToggle = function (bool) {
        setExpand(bool);
        setExpandProp && setExpandProp(bool);
    };
    (0, react_1.useEffect)(function () {
        if (expandProp !== expand) {
            setExpand(expandProp);
        }
    }, [expandProp]);
    var HeaderStyles = {
        HeaderStyle1: HeaderStyle1,
        HeaderStyle2: HeaderStyle2,
        HeaderStyle3: HeaderStyle3,
    };
    var genHeader = function () {
        if (CustomHeader)
            return CustomHeader;
        var HeaderStyleComp = HeaderStyles[HeaderStyle];
        if (!HeaderStyleComp)
            return (react_1.default.createElement("div", { style: { padding: '1rem 2rem', background: colors_1.colors.red } },
                react_1.default.createElement(Typo_1.SANS_2, null, 'Incorrect accordion HeaderStyle')));
        return (react_1.default.createElement(HeaderStyleComp, { handleToggle: handleToggle, expand: expand, title: title, label: label, infoTooltip: infoTooltip, invert: invert, percent: percent }));
    };
    return (react_1.default.createElement("div", { id: id },
        !noHeader && genHeader(),
        react_1.default.createElement(styled_1.StyledAccordionContentsWrapper, { initial: { height: expand ? 'auto' : 0 }, animate: { height: expand ? 'auto' : 0 }, transition: { type: 'tween', ease: 'easeOut' } },
            react_1.default.createElement("div", null, children))));
};
exports.Accordion = Accordion;
